import Vue from 'vue'
import App from './views/App.vue'
import axios from "axios";
import router from './js/router'
import store from './js/store'
import util from './js/util'
import api from './js/api'
import md5 from "./js/md5utf8.js";

Vue.config.productionTip = false;
Vue.prototype.axios = axios;
Vue.prototype.util = util;
Vue.prototype.api = api;
Vue.prototype.md5 = md5;

new Vue({
    router,
    store,
    render: h => h(App),
    data: { eventHub: new Vue() }
}).$mount('#app');